export * from './async';
export * from './pages';

import { pagesSlice } from './slice';

const Reducer = pagesSlice.reducer;
const Actions = pagesSlice.actions;

export { Reducer, Actions };
